// extracted by mini-css-extract-plugin
export default {"page":"page__9qKFz","layout":"layout__zE4Z+","header":"header__NQ8ZH","panel":"panel__uNQv2"};